export default "__VITE_ASSET__DQQfI2Jy__"